import {call, put, takeLatest} from 'redux-saga/effects';
import {
  loginOtpFailure,
  loginOtpRequest,
  loginOtpSuccess,
  signupOtpFailure,
  signupOtpRequest,
  signupOtpSuccess,
  loginOTPVerifyFailure,
  loginOTPVerifyRequest,
  loginOTPVerifySuccess,
  loginOtpResendFailure,
  loginOtpResendRequest,
  loginOtpResendSuccess,
  signupOtpResendFailure,
  signupOtpResendRequest,
  signupOtpResendSuccess,
  singupOTPVerifyFailure,
  singupOTPVerifyRequest,
  singupOTPVerifySuccess,
  getProfileFailure,
  getProfileRequest,
  getProfileSuccess,
  specialistSignupOtpFailure,
  specialistSignupOtpRequest,
  specialistSignupOtpSuccess,
  verifyLicenceFailure,
  verifyLicenceRequest,
  verifyLicenceSuccess,
  loginMFAVerifyFailure,
  loginMFAVerifyRequest,
  loginMFAVerifySuccess,
  signupMFAVerifyFailure,
  signupMFAVerifyRequest,
  signupMFAVerifySuccess,
  loginMFAResendRequest,
  loginMFAResendFailure,
  loginMFAResendSuccess,
  signupMFAResendFailure,
  signupMFAResendRequest,
  signupMFAResendSuccess,
  editProfileFailure,
  editProfileRequest,
  editProfileSuccess,
  profileOtpRequestFailure,
  profileOtpRequestRequest,
  profileOtpRequestSuccess,
  profileOtpResendRequest,
  profileOtpResendFailure,
  profileOtpResendSuccess,
  profileOtpVerifyRequest,
  profileOtpVerifyFailure,
  profileOtpVerifySuccess,
  getSpecialistProfileRequest,
  getSpecialistProfileSuccess,
  getSpecialistProfileFailure,
  updateSpecialistProfileRequest,
  updateSpecialistProfileSuccess,
  updateSpecialistProfileFailure,
  submitSpecialistProfileApprovalRequest,
  submitSpecialistProfileApprovalSuccess,
  submitSpecialistProfileApprovalFailure,
  // patient setting export
  patientAccountExportFailure,
  patientAccountExportSuccess,
  patientAccountExportRequest,

  //patient setting deletion
  patientAccountDeletion,
  patientAccountDeletionSuccess,
  patientAccountDeletionFailure,
  //patient settting cancel deletion
  patientAccountCancelation,
  patientAccountCancelationSuccess,
  patientAccountCancelationFailure,

  // validate specialist invitation
  validateSpecialistInvitationRequest,
  validateSpecialistInvitationSuccess,
  validateSpecialistInvitationFailure,

  // account ticket status  getAccountTicketStatusRequest,
  getAccountTicketStatusRequest,
  getAccountTicketStatusSuccess,
  getAccountTicketStatusFailure,

  // logout
  logoutFailure,
  logoutRequest,
  logoutSuccess,
} from '../slices/authSlice';

import {
  loginOtpRequest as loginOtpRequestAPI,
  signupOtpRequest as signupOtpRequestAPI,
  loginOtpVerify,
  signupOtpVerify,
  loginOtpResend,
  signupOtpResend,
  viewProfile,
  editProfile,
  loginMfaResend,
  loginMfaVerify,
  signupMfaResend,
  signupMfaVerify,
  specialistSignupOtpRequest as specialistSignupOtpRequestAPI,
  verifyLicence,
  profileOtpRequest,
  profileOtpResend,
  profileOtpVerify,
  getSpecialistProfile,
  updateSpecialistProfile,
  submitSpecialistProfileApproval,
  patientSettingExport,
  patientDelete,
  CancelPatientData,
  validateSpecialistInvitation,
  accountTicketStatus,
  logout,
} from '@/services/api';
import {SUCCESS_KEY} from '@/constants/keys';

function* loginOtpRequestSaga(action: any): Generator {
  try {
    const response: any = yield call(loginOtpRequestAPI, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(loginOtpSuccess(response.data));
    } else {
      yield put(loginOtpFailure(response.data));
    }
  } catch (error: any) {
    yield put(loginOtpFailure(error.response));
  }
}

function* signupOtpRequestSaga(action: any): Generator {
  try {
    const response: any = yield call(signupOtpRequestAPI, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(signupOtpSuccess(response.data));
    } else {
      yield put(signupOtpFailure(response.data));
    }
  } catch (error: any) {
    yield put(signupOtpFailure(error.response));
  }
}

function* loginOtpVerifySaga(action: any): Generator {
  try {
    const response: any = yield call(loginOtpVerify, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(loginOTPVerifySuccess(response.data));
    } else {
      yield put(loginOTPVerifyFailure(response.data));
    }
  } catch (error: any) {
    yield put(loginOTPVerifyFailure(error.response));
  }
}

function* SignupOtpVerifySaga(action: any): Generator {
  try {
    const response: any = yield call(signupOtpVerify, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(singupOTPVerifySuccess(response.data));
    } else {
      yield put(singupOTPVerifyFailure(response.data));
    }
  } catch (error: any) {
    yield put(singupOTPVerifyFailure(error.response));
  }
}

function* SignupOtpResendSaga(action: any): Generator {
  try {
    const response: any = yield call(signupOtpResend, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(signupOtpResendSuccess(response.data));
    } else {
      yield put(signupOtpResendFailure(response.data));
    }
  } catch (error: any) {
    yield put(signupOtpResendFailure(error.response));
  }
}

function* LoginOtpResendSaga(action: any): Generator {
  try {
    const response: any = yield call(loginOtpResend, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(loginOtpResendSuccess(response.data));
    } else {
      yield put(loginOtpResendFailure(response.data));
    }
  } catch (error: any) {
    yield put(loginOtpResendFailure(error.response));
  }
}

function* ViewProfileSaga(): Generator {
  try {
    const response: any = yield call(viewProfile);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getProfileSuccess(response.data));
    } else {
      yield put(getProfileFailure(response.data));
    }
  } catch (error: any) {
    yield put(getProfileFailure(error.response));
  }
}

function* EditProfileSaga(action: any): Generator {
  try {
    const response: any = yield call(editProfile, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(editProfileSuccess(response.data));
    } else {
      yield put(editProfileFailure(response.data));
    }
  } catch (error: any) {
    yield put(editProfileFailure(error.response));
  }
}

function* SpecialistSignupOTPRequestSaga(action: any): Generator {
  try {
    const response: any = yield call(specialistSignupOtpRequestAPI, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(
        specialistSignupOtpSuccess({
          response_date: response.data,
          request_payload: action.payload,
        }),
      );
    } else {
      yield put(specialistSignupOtpFailure(response.data));
    }
  } catch (error: any) {
    yield put(specialistSignupOtpFailure(error.response));
  }
}

function* VerifyLicenceSaga(action: any): Generator {
  try {
    const response: any = yield call(verifyLicence, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(verifyLicenceSuccess(response.data));
    } else {
      yield put(verifyLicenceFailure(response.data));
    }
  } catch (error: any) {
    yield put(verifyLicenceFailure(error.response));
  }
}

function* LoginMfaVerifySaga(action: any): Generator {
  try {
    const response: any = yield call(loginMfaVerify, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(loginMFAVerifySuccess(response.data));
    } else {
      yield put(loginMFAVerifyFailure(response.data));
    }
  } catch (error: any) {
    yield put(loginMFAVerifyFailure(error.response));
  }
}

function* SignupMfaVerifySaga(action: any): Generator {
  try {
    const response: any = yield call(signupMfaVerify, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(signupMFAVerifySuccess(response.data));
    } else {
      yield put(signupMFAVerifyFailure(response.data));
    }
  } catch (error: any) {
    yield put(signupMFAVerifyFailure(error.response));
  }
}

function* LoginMfaResendSaga(action: any): Generator {
  try {
    const response: any = yield call(loginMfaResend, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(loginMFAResendSuccess(response.data));
    } else {
      yield put(loginMFAResendFailure(response.data));
    }
  } catch (error: any) {
    yield put(loginMFAResendFailure(error.response));
  }
}

function* SignupMfaResendSaga(action: any): Generator {
  try {
    const response: any = yield call(signupMfaResend, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(signupMFAResendSuccess(response.data));
    } else {
      yield put(signupMFAResendFailure(response.data));
    }
  } catch (error: any) {
    yield put(signupMFAResendFailure(error.response));
  }
}

function* ProfileOtpRequestSaga(action: any): Generator {
  try {
    const response: any = yield call(profileOtpRequest, action.payload);
    const value = action.payload.value;
    if (response.data.status === SUCCESS_KEY) {
      yield put(profileOtpRequestSuccess({...response.data, value}));
    } else {
      yield put(profileOtpRequestFailure(response.data));
    }
  } catch (error: any) {
    yield put(profileOtpRequestFailure(error.response));
  }
}

function* ProfileOtpResendSaga(action: any): Generator {
  try {
    const response: any = yield call(profileOtpResend, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(profileOtpResendSuccess(response.data));
    } else {
      yield put(profileOtpResendFailure(response.data));
    }
  } catch (error: any) {
    yield put(profileOtpResendFailure(error.response));
  }
}

function* ProfileOtpVerifySaga(action: any): Generator {
  try {
    const response: any = yield call(profileOtpVerify, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(profileOtpVerifySuccess(response.data));
    } else {
      yield put(profileOtpVerifyFailure(response.data));
    }
  } catch (error: any) {
    yield put(profileOtpVerifyFailure(error.response));
  }
}

function* GetSpecialistProfileSaga(): Generator {
  try {
    const response: any = yield call(getSpecialistProfile);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getSpecialistProfileSuccess(response.data));
    } else {
      yield put(getSpecialistProfileFailure(response.data));
    }
  } catch (error: any) {
    yield put(getSpecialistProfileFailure(error.response));
  }
}

function* UpdateSpecialistProfileSaga(action: any): Generator {
  try {
    const response: any = yield call(updateSpecialistProfile, action.payload);

    const responseData = response?.data;

    // Check if response has data property
    if (responseData) {
      if (responseData.status === SUCCESS_KEY) {
        yield put(updateSpecialistProfileSuccess(responseData));
        // Delay refetch to allow toast to be displayed first
        yield new Promise(resolve => setTimeout(resolve, 100));
        // Refetch specialist profile data to get updated details
        yield put(getSpecialistProfileRequest());
      } else {
        // Response has data but status is not success
        yield put(updateSpecialistProfileFailure(responseData));
      }
    } else {
      yield put(updateSpecialistProfileFailure({status: 'error', status_code: 'E-10001'}));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || error?.data || error;
    yield put(updateSpecialistProfileFailure(errorData || {status: 'error', status_code: 'E-10001'}));
  }
}

function* SubmitSpecialistProfileApprovalSaga(action: any): Generator {
  try {
    const response: any = yield call(submitSpecialistProfileApproval);

    const responseData = response?.data;

    // Check if response has data property
    if (responseData) {
      if (responseData.status === SUCCESS_KEY) {
        yield put(submitSpecialistProfileApprovalSuccess(responseData));
        // Delay refetch to allow toast to be displayed first
        yield new Promise(resolve => setTimeout(resolve, 100));
        // Refetch specialist profile data to get updated status
        yield put(getSpecialistProfileRequest());
      } else {
        // Response has data but status is not success
        yield put(submitSpecialistProfileApprovalFailure(responseData));
      }
    } else {
      yield put(submitSpecialistProfileApprovalFailure({status: 'error', status_code: 'E-10001'}));
    }
  } catch (error: any) {
    const errorData = error?.response?.data || error?.data || error;
    yield put(submitSpecialistProfileApprovalFailure(errorData || {status: 'error', status_code: 'E-10001'}));
  }
}
function* getPatientAccountExportSaga(action: any): Generator {
  try {
    const response: any = yield call(patientSettingExport, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(patientAccountExportSuccess(response.data));
    } else {
      yield put(patientAccountExportFailure(response.data));
    }
  } catch (error: any) {
    yield put(patientAccountExportFailure(error.response));
  }
}
function* getPatientAccountDeletionSaga(action: any): Generator {
  try {
    const response: any = yield call(patientDelete, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(patientAccountDeletionSuccess(response.data));
    } else {
      yield put(patientAccountDeletionFailure(response.data));
    }
  } catch (error: any) {
    yield put(patientAccountExportFailure(error.response || {status: 'error', status_code: 'E-10001'}));
  }
}

function* getPatientAccountCancelationSaga(): Generator {
  try {
    const response: any = yield call(CancelPatientData);
    if (response.data.status === SUCCESS_KEY) {
      yield put(patientAccountCancelationSuccess(response.data));
    } else {
      yield put(patientAccountCancelationFailure(response.data));
    }
  } catch (error: any) {
    yield put(patientAccountExportFailure(error.response || {status: 'error', status_code: 'E-10001'}));
  }
}
function* ValidateSpecialistInvitationSaga(action: any): Generator {
  try {
    const response: any = yield call(validateSpecialistInvitation, action.payload);
    if (response.data.status === SUCCESS_KEY) {
      yield put(validateSpecialistInvitationSuccess(response.data));
    } else {
      yield put(validateSpecialistInvitationFailure(response.data));
    }
  } catch (error: any) {
    yield put(validateSpecialistInvitationFailure(error.response));
  }
}

function* LogoutSaga(): Generator {
  try {
    const response: any = yield call(logout);
    if (response.data.status === SUCCESS_KEY) {
      yield put(logoutSuccess(response.data));
    } else {
      yield put(logoutFailure(response.data));
    }
  } catch (error: any) {
    yield put(logoutFailure(error.response));
  }
}

function* AccountTicketStatusSaga(): Generator {
  try {
    const response: any = yield call(accountTicketStatus);
    if (response.data.status === SUCCESS_KEY) {
      yield put(getAccountTicketStatusSuccess(response.data));
    } else {
      yield put(getAccountTicketStatusFailure(response.data));
    }
  } catch (error: any) {
    yield put(getAccountTicketStatusFailure(error.response));
  }
}

export default function* authSaga(): Generator {
  yield takeLatest(loginOtpRequest.type, loginOtpRequestSaga);
  yield takeLatest(signupOtpRequest.type, signupOtpRequestSaga);
  yield takeLatest(loginOTPVerifyRequest.type, loginOtpVerifySaga);
  yield takeLatest(singupOTPVerifyRequest.type, SignupOtpVerifySaga);
  yield takeLatest(signupOtpResendRequest.type, SignupOtpResendSaga);
  yield takeLatest(loginOtpResendRequest.type, LoginOtpResendSaga);
  yield takeLatest(getProfileRequest.type, ViewProfileSaga);
  yield takeLatest(specialistSignupOtpRequest.type, SpecialistSignupOTPRequestSaga);
  yield takeLatest(verifyLicenceRequest.type, VerifyLicenceSaga);
  yield takeLatest(loginMFAVerifyRequest.type, LoginMfaVerifySaga);
  yield takeLatest(signupMFAVerifyRequest.type, SignupMfaVerifySaga);
  yield takeLatest(loginMFAResendRequest.type, LoginMfaResendSaga);
  yield takeLatest(signupMFAResendRequest.type, SignupMfaResendSaga);
  yield takeLatest(editProfileRequest.type, EditProfileSaga);
  yield takeLatest(profileOtpRequestRequest.type, ProfileOtpRequestSaga);
  yield takeLatest(profileOtpResendRequest.type, ProfileOtpResendSaga);
  yield takeLatest(profileOtpVerifyRequest.type, ProfileOtpVerifySaga);
  yield takeLatest(getSpecialistProfileRequest.type, GetSpecialistProfileSaga);
  yield takeLatest(updateSpecialistProfileRequest.type, UpdateSpecialistProfileSaga);
  yield takeLatest(submitSpecialistProfileApprovalRequest.type, SubmitSpecialistProfileApprovalSaga);
  yield takeLatest(patientAccountExportRequest.type, getPatientAccountExportSaga);
  yield takeLatest(patientAccountDeletion.type, getPatientAccountDeletionSaga);
  yield takeLatest(patientAccountCancelation.type, getPatientAccountCancelationSaga);
  yield takeLatest(validateSpecialistInvitationRequest.type, ValidateSpecialistInvitationSaga);
  yield takeLatest(logoutRequest.type, LogoutSaga);
  yield takeLatest(getAccountTicketStatusRequest.type, AccountTicketStatusSaga);
}
